<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  import {mapActions, mapMutations, mapState} from "vuex"; 

  export default {
    name: "Admin",
    created() {
      if(this.currentUser.user_type === 'Partner'){
        this.SET_PARTNER_NAMESPACE(null);
        this.$router.push({name:'root'});
      }else{ 
        this.fetchZones({limit: 400}); 
        this.fetchPartners({page:1}); 
        this.fetchGroups({limit: 10000});
        this.SET_PARTNER_NAMESPACE(null);
      }
    },
    computed: {
      ...mapState('users',['currentUser'])
    },
    methods:{
      ...mapActions('zones',['fetchZones']),
      ...mapActions('groups',['fetchGroups']),
      ...mapActions('partners',['fetchPartners']),
      ...mapMutations(['SET_PARTNER_NAMESPACE'])
    }
  }
</script>

<style scoped>

</style>
